import { translationMissingAction } from './../../app/@store/common.actions';
import { Store } from '@ngrx/store';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from "@ngx-translate/core";
import { has, isString, get } from 'lodash';

export class GSMissingTranslationHandler implements MissingTranslationHandler {
  missingTranslationsReported: string[] = [];
  constructor(private readonly store: Store) { }

  handle(params: MissingTranslationHandlerParams) {
    if (has(params, 'key') && isString(params.key)) {
      if (params.key.substr(0, 1) === params.key.substr(0, 1).toLowerCase() && params.key.length > 1) {

        let lang = "-";
        if (has(params, 'translateService') && has(params.translateService, 'store') && has(params.translateService.store, 'currentLang') && params.translateService.store.currentLang !== undefined) {
          lang = params.translateService.store.currentLang;
        }

        if (params.interpolateParams && get(params.interpolateParams, '__ignore') === true) {
          return params.key;
        }

        if (this.missingTranslationsReported.indexOf(params.key) >= 0) return; // already reported
        this.missingTranslationsReported.push(params.key);

        if (window.location.hostname != 'localhost') {
          setTimeout(() => {
            this.store.dispatch(translationMissingAction({
              key: params.key,
              language: lang
            }));
          }, 500);

        } else {
          console.warn('Missing translation!', params.key, lang, 'Hint: Add `__ignore: true` as a interpolation parameter if this is intended');
        }

      }
      return params.key;
    }

    return "";
  }
}
